/**
 * Created by Ning Jiang on 2021-05-21.
 */

import {ReelStopPresentationController} from "./ReelStopPresentationController";

export class ReelStopPresentationManager {

    private readonly _presentations:ReelStopPresentationController[];

    constructor(presentations:ReelStopPresentationController[]) {
        this._presentations = presentations.concat();
        if(this._presentations.length === 0) {
            //TODO: Use this to add a default one to hold the promise for the stop events. remove this if new presentations added.
            this._presentations.push(new ReelStopPresentationController("default"));
        }
    }

    public async start():Promise<any> {
        await Promise.all(this._presentations.map(p => p.start()));
    }

    public skip():void {
        this._presentations.forEach(p => p.skip());
    }
}